import style from './style.module.css';

const BodyContainer = ({ children, className }) => <div className={`${style.body} ${className}`}>{children}</div>;

export default BodyContainer;
